import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import ProfileDetails from '../../MyAccount/ProfileDetails/ProfileDetails';
import AboutHorses from '../../../components/HorsesCard/AboutHorses/AboutHorses';
import cn from 'classnames';
import styles from './RaceStatistic.module.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
const RaceStatistic = ({ raceStats, dealsData }) => {
    const { t } = useTranslation();
    return (_jsx(_Fragment, { children: _jsx(ProfileDetails, Object.assign({ title: t('races_statistic') }, { children: _jsx(AboutHorses, { className: cn(styles.raceStats, 'd-flex'), elem: raceStats }) })) }));
};
export default RaceStatistic;
